module.exports = __webpack_public_path__ + "img/app-store.e0d66711.png";